import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

/**
 * Interface for reset password payload
 */
export interface ResetPasswordPayload {
  email: string;
  token: string;
  password: string;
}

/**
 * Hook for resetting password using TanStack React Query
 */
export const useResetPassword = (
  setSuccess: (value: boolean) => void,
  setClear: (value: ((prev: boolean) => boolean) | boolean) => void
) => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async (payload: ResetPasswordPayload) => {
      const response = await apiClient.post<void>('/auth/reset-password/', payload);
      return response.data;
    },
    onSuccess: () => {
      setSuccess(true);
      setClear((prev) => !prev);
      openToast({
        show: true,
        heading: 'Success',
        text: 'Password reset successfully!',
        type: 'info',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      console.error('Reset Password Error:', err); // Log error for debugging
      const errorMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error?.message ||
        'Failed to change password, please try again later';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};